// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
//== Font classes to mixin
@font-size-saturn:  14px;
@font-size-neptune: 12px;
@font-size-venus:   11px;
@font-size-mars:    13px;
@font-size-jackdaw: 11px;
@font-size-magpie:  18px;
@font-size-crow:    24px;
@font-size-special: 16px;

.flow-special-one {
  font: @font-size-special 'Gotham Bold';
  color: @flow-app-dark-grey;
}

.flow-jupiter-one {
  font: @font-size-jupiter 'Gotham Light';
  color: @flow-app-dark-grey;
}

.flow-jupiter-invert {
  font: @font-size-jupiter 'Gotham Light';
  color: @flow-app-white;
}

.flow-saturn-one {
  font: @font-size-saturn 'Gotham Book';
  color: @flow-app-dark-grey;
}

.flow-saturn-two {
  font: @font-size-saturn 'Gotham Bold';
  color: @flow-app-dark-grey;
}

.flow-saturn-three {
  font: @font-size-saturn 'Gotham Book';
  color: @flow-app-icon;
}

.flow-saturn-medium {
  font: @font-size-saturn 'Gotham Medium';
  color: @flow-app-dark-grey;
}

.flow-saturn-invert {
  font: @font-size-saturn 'Gotham Book';
  color: @flow-app-white;
}

.flow-saturn-light {
  font: @font-size-saturn 'Gotham Light';
  color: @flow-app-light-grey;
}

.flow-neptune-one {
  font: @font-size-neptune 'Gotham Light'; // 0.875 = @font-size-neptune
  color: @flow-app-light-grey;
}

.flow-neptune-two {
    font: @font-size-neptune 'Gotham Book';
    color: @flow-app-dark-grey;
}

.flow-neptune-three {
  font: @font-size-neptune 'Gotham Book';
  color: @flow-app-mid-grey;
}

.flow-neptune-bold {
    font: @font-size-neptune 'Gotham Bold';
    color: @flow-app-dark-grey;
}

.flow-neptune-medium {
  font: @font-size-neptune 'Gotham Medium';
  color: @flow-app-dark-grey;
}

.flow-neptune-medium-special {
  font: @font-size-neptune 'Gotham Medium';
  color: @flow-app-dark-grey;
  letter-spacing: 1px;
}

.flow-neptune-invert {
  font: @font-size-neptune 'Gotham Medium';
  color: @flow-app-white;
}

.flow-venus-one {
  font: @font-size-venus 'Gotham Book';
  color: @flow-app-dark-grey;
}

.flow-venus-two {
  font: @font-size-venus 'Gotham Book';
  color: @flow-app-mid-grey;
}

.flow-venus-two-special {
  font: @font-size-venus 'Gotham Light';
  color: @flow-app-light-grey;
  letter-spacing: 1px;
}

.flow-venus-three {
  font: @font-size-venus 'Gotham Book';
  color: @flow-app-light-grey;
}

// Only used for old video service remove when we the new video solution takes over.
.flow-venus-special {
  font: @font-size-venus 'Gotham Book';
  color: @flow-app-red;
}

.flow-venus-invert {
  font: @font-size-venus 'Gotham Book';
  color: @flow-app-white;
}

.flow-venus-invert-60 {
  font: @font-size-venus 'Gotham Book';
  color: @flow-app-white;
  opacity: 0.6;
}

.flow-mars-one {
  font: @font-size-mars 'Gotham Book';
  color: @flow-app-mid-grey;
}

.flow-mars-two {
  font: @font-size-mars 'Gotham Book';
  color: @flow-app-dark-grey;
}

.jackdaw {
  font: @font-size-jackdaw 'Gotham Medium';
  color: @flow-app-dark-grey;
}

.magpie {
  font: @font-size-magpie 'Gotham Medium';
  color: @flow-app-dark-grey;
}

.crow {
  font: @font-size-crow 'Gotham Medium';
  color: @flow-app-dark-grey;
}
*/
.flow-title-special {
  font: 16px 'Roboto-Bold';
  color: #242424;
}
.flow-special-font {
  font: 32px 'Roboto-Light';
  color: #727272;
}
.flow-profile-bold {
  font: 12px 'Roboto-Bold';
  color: #242424;
}
.flow-profile-regular {
  font: 12px 'Roboto-Regular';
  color: #242424;
}
.flow-top-bar-title {
  font: 14px 'Roboto-Bold';
  color: #242424;
}
.flow-list-item-title {
  font: 14px 'Roboto-Regular';
  color: #242424;
}
.flow-list-item-title-alt {
  font: 14px 'Roboto-Bold';
  color: #242424;
}
.flow-list-item-second {
  font: 12px 'Roboto-Regular';
  color: #727272;
}
.flow-list-item-second-dark {
  font: 12px 'Roboto-Regular';
  color: #242424;
}
.flow-list-item-second-alt {
  font: 12px 'Roboto-Medium';
  color: #3f4142;
}
.flow-list-item-third {
  font: 12px 'Roboto-Regular';
  color: #3f4142;
}
.flow-list-item-third-alt {
  font: 12px 'Roboto-Bold';
  color: #3f4142;
}
.flow-section-title {
  font: 12px 'Roboto-Bold';
  color: #242424;
}
.flow-suggestion-item-title {
  font: 12px 'Roboto-Bold';
  color: #242424;
}
.flow-time {
  font: 12px 'Roboto-Regular';
  color: #727272;
}
.flow-settings-item {
  font: 14px 'Roboto-Regular';
  color: #242424;
}
.flow-settings-item-second {
  font: 12px 'Roboto-Medium';
  color: #727272;
}
.flow-settings-text {
  font: 12px 'Roboto-Regular';
  color: #727272;
}
.flow-settings-item-header {
  font: 12px 'Roboto-Regular';
  color: #727272;
}
.flow-headline {
  font: 24px 'Roboto-Bold';
  color: #242424;
}
.flow-headline-two {
  font: 14px 'Roboto-Regular';
  color: #727272;
}
.flow-headline-three {
  font: 18px 'Roboto-Regular';
  color: #242424;
}
.open-graph-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  max-height: 34px;
  overflow: hidden;
  font: 14px 'Roboto-Bold';
  color: #ffffff;
}
.open-graph-description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  max-height: 32px;
  overflow: hidden;
  font: 12px 'Roboto-Regular';
  color: #d7d7d7;
}
.open-graph-site-name {
  font: 10px 'Roboto-Regular';
  color: #adadad;
}
.callmodal-caller {
  font: 14px 'Roboto-Regular';
  color: #ffffff;
}
.callmodal-info {
  font: 12px 'Roboto-Regular';
  color: #adadad;
}
.callmodal-state {
  font: 12px 'Roboto-Bold';
  color: #ffffff;
}
.flow-italic-one {
  font: 12px 'Roboto-Regular';
  color: #adadad;
  font-style: italic;
}
.flow-italic-two {
  font: 12px 'Roboto-Bold';
  color: #adadad;
  font-style: italic;
}
.dark .big-calendar .flow-list-item-title {
  color: var(--color-black);
}
.dark .big-calendar .rbc-time-view {
  background-color: var(--color-dark-background);
  border-color: var(--color-light-grey);
}
.dark .big-calendar .rbc-day-slot .rbc-time-slot,
.dark .big-calendar .rbc-time-content,
.dark .big-calendar .rbc-day-bg + .rbc-day-bg,
.dark .big-calendar .rbc-timeslot-group,
.dark .big-calendar .rbc-time-header-content,
.dark .big-calendar .rbc-header {
  border-color: var(--color-light-grey);
}
.dark .big-calendar .rbc-today {
  background-color: var(--color-mid-grey);
}
.dark .big-calendar .rbc-toolbar,
.dark .big-calendar .rbc-time-gutter,
.dark .big-calendar .rbc-header-gutter,
.dark .big-calendar .rbc-header,
.dark .big-calendar .rbc-time-view .rbc-btn-group > button {
  color: var(--white);
  background-color: var(--color-dark-background);
}
.dark .big-calendar .rbc-header.rbc-today {
  color: var(--white);
}
.big-calendar .rbc-calendar * {
  z-index: 1;
}
.big-calendar .rbc-time-view {
  background-color: #ffffff;
}
.big-calendar .rbc-toolbar {
  display: flex;
  justify-content: space-between;
  height: 50px;
}
.big-calendar .rbc-toolbar-label {
  font: 14px 'Roboto-Regular';
  color: #242424;
  text-align: left;
  padding-left: 0;
}
.big-calendar .rbc-time-gutter,
.big-calendar .rbc-header-gutter,
.big-calendar .rbc-header,
.big-calendar .rbc-btn-group > button {
  font: 12px 'Roboto-Regular';
  color: #242424;
  font-size: 11px;
  word-break: inherit;
}
.big-calendar .rbc-time-gutter,
.big-calendar .rbc-header-gutter {
  width: 12.5% !important;
}
.big-calendar .rbc-time-gutter {
  white-space: normal;
}
.big-calendar .rbc-btn-group > button:focus {
  outline: none;
}
.big-calendar .rbc-header.rbc-today {
  font: 12px 'Roboto-Regular';
  color: #727272;
  font-size: 11px;
}
.big-calendar .rbc-header {
  padding: 3px;
  white-space: inherit;
}
.big-calendar .rbc-day-slot .rbc-event {
  border: none;
  width: auto !important;
}
.big-calendar .rbc-event {
  padding: 0;
  background: transparent;
  border-radius: 0px;
  margin-right: -10px;
}
.big-calendar .rbc-event .rbc-addons-dnd-resizable {
  height: 100%;
}
.big-calendar .rbc-event .rbc-event-label {
  display: none;
}
.big-calendar .rbc-event .custom-event {
  height: 100%;
  display: flex;
  flex-direction: row;
}
.big-calendar .rbc-event .custom-event .event-placeholder {
  width: 10px;
  flex-shrink: 0;
}
.big-calendar .rbc-event .custom-event .event-content {
  word-break: break-word;
}
.big-calendar .rbc-event .custom-event .event-content .custom-event-title {
  font: 14px 'Roboto-Regular';
  color: #242424;
  font-size: 12px;
  word-break: keep-all;
}
.big-calendar .rbc-event .custom-event .event-content .custom-event-time {
  font: 12px 'Roboto-Regular';
  color: #727272;
  font-size: 11px;
}
.big-calendar .rbc-event .custom-event.non-editable {
  cursor: not-allowed;
}
.big-calendar .profile-container {
  margin: 20px 0 0;
  display: flex;
  flex-flow: row wrap;
}
.chat-session .custom-event-time,
.extension .custom-event-time,
.columns-1.onlyContent .custom-event-time,
.chat-session .custom-event-title,
.extension .custom-event-title,
.columns-1.onlyContent .custom-event-title {
  visibility: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/app/flow/components/calendar/css/calendar-week.less","webpack://./style_modules/less-components/styles/fonts.less"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA0JC;ACeD;EACE,wBAAA;EACA,cAAA;ADbF;ACgBA;EACE,yBAAA;EACA,cAAA;ADdF;ACiBA;EACE,wBAAA;EACA,cAAA;ADfF;ACkBA;EACE,2BAAA;EACA,cAAA;ADhBF;ACmBA;EACE,wBAAA;EACA,cAAA;ADjBF;ACoBA;EACE,2BAAA;EACA,cAAA;ADlBF;ACqBA;EACE,wBAAA;EACA,cAAA;ADnBF;ACsBA;EACE,2BAAA;EACA,cAAA;ADpBF;ACuBA;EACE,2BAAA;EACA,cAAA;ADrBF;ACwBA;EACE,0BAAA;EACA,cAAA;ADtBF;ACyBA;EACE,2BAAA;EACA,cAAA;ADvBF;AC0BA;EACE,wBAAA;EACA,cAAA;ADxBF;AC2BA;EACE,wBAAA;EACA,cAAA;ADzBF;AC4BA;EACE,wBAAA;EACA,cAAA;AD1BF;AC6BA;EACE,2BAAA;EACA,cAAA;AD3BF;AC8BA;EACE,2BAAA;EACA,cAAA;AD5BF;AC+BA;EACE,0BAAA;EACA,cAAA;AD7BF;ACgCA;EACE,2BAAA;EACA,cAAA;AD9BF;ACiCA;EACE,2BAAA;EACA,cAAA;AD/BF;ACkCA;EACE,wBAAA;EACA,cAAA;ADhCF;ACmCA;EACE,2BAAA;EACA,cAAA;ADjCF;ACoCA;EACE,2BAAA;EACA,cAAA;ADlCF;ACqCA;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;ADnCF;ACsCA;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,cAAA;ADpCF;ACuCA;EACE,2BAAA;EACA,cAAA;ADrCF;ACwCA;EACE,2BAAA;EACA,cAAA;ADtCF;ACyCA;EACE,2BAAA;EACA,cAAA;ADvCF;AC0CA;EACE,wBAAA;EACA,cAAA;ADxCF;AC2CA;EACE,2BAAA;EACA,cAAA;EACA,kBAAA;ADzCF;AC4CA;EACE,wBAAA;EACA,cAAA;EACA,kBAAA;AD1CF;AA9RA;EAGY,yBAAA;AA8RZ;AAjSA;EAMY,8CAAA;EACA,qCAAA;AA8RZ;AArSA;;;;;;EAeY,qCAAA;AA8RZ;AA7SA;EAkBY,uCAAA;AA8RZ;AAhTA;;;;;EA0BY,mBAAA;EACA,8CAAA;AA6RZ;AAxTA;EA+BY,mBAAA;AA4RZ;AAvRA;EAEQ,UAAA;AAwRR;AA1RA;EAMQ,yBAAA;AAuRR;AA7RA;EAUQ,aAAA;EACA,8BAAA;EACA,YAAA;AAsRR;AAlSA;EC6JE,2BAAA;EACA,cAAA;ED9IM,gBAAA;EACA,eAAA;AAuRR;AAxSA;;;;EC4KE,2BAAA;EACA,cAAA;EDpJM,eAAA;EACA,mBAAA;AAuRR;AAjTA;;EA+BQ,uBAAA;AAsRR;AArTA;EAmCQ,mBAAA;AAqRR;AAxTA;EAuCQ,aAAA;AAoRR;AA3TA;ECuKE,2BAAA;EACA,cAAA;ED5HM,eAAA;AAoRR;AAhUA;EAgDQ,YAAA;EACA,oBAAA;AAmRR;AApUA;EAqDQ,YAAA;EACA,sBAAA;AAkRR;AAxUA;EA0DQ,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AAiRR;AA9UA;EAgEY,YAAA;AAiRZ;AAjVA;EAoEY,aAAA;AAgRZ;AApVA;EAwEY,YAAA;EACA,aAAA;EACA,mBAAA;AA+QZ;AAzVA;EA6EgB,WAAA;EACA,cAAA;AA+QhB;AA7VA;EAkFgB,sBAAA;AA8QhB;AAhWA;EC6JE,2BAAA;EACA,cAAA;EDxEkB,eAAA;EACA,oBAAA;AA+QpB;AAtWA;EC0ME,2BAAA;EACA,cAAA;ED/GkB,eAAA;AA+QpB;AA3WA;EAkGY,mBAAA;AA4QZ;AA9WA;EAuGQ,gBAAA;EACA,aAAA;EACA,mBAAA;AA0QR;AAtQA;;;;;;EAKQ,kBAAA;AAyQR","sourcesContent":["@import '~less-components/styles/components.less';\n\n.dark {\n    .big-calendar {\n        .flow-list-item-title {\n            color: var(--color-black);\n        }\n        .rbc-time-view {\n            background-color: var(--color-dark-background);\n            border-color: var(--color-light-grey);\n        }\n        .rbc-day-slot .rbc-time-slot,\n        .rbc-time-content,\n        .rbc-day-bg + .rbc-day-bg,\n        .rbc-timeslot-group,\n        .rbc-time-header-content,\n        .rbc-header {\n            border-color: var(--color-light-grey);\n        }\n        .rbc-today {\n            background-color: var(--color-mid-grey);\n        }\n\n        .rbc-toolbar,\n        .rbc-time-gutter,\n        .rbc-header-gutter,\n        .rbc-header,\n        .rbc-time-view .rbc-btn-group > button {\n            color: var(--white);\n            background-color: var(--color-dark-background);\n        }\n\n        .rbc-header.rbc-today {\n            color: var(--white);\n        }\n    }\n}\n\n.big-calendar {\n    .rbc-calendar * {\n        z-index: 1;\n    }\n\n    .rbc-time-view {\n        background-color: @flow-app-white;\n    }\n\n    .rbc-toolbar {\n        display: flex;\n        justify-content: space-between;\n        height: 50px;\n    }\n    .rbc-toolbar-label {\n        .flow-list-item-title;\n        text-align: left;\n        padding-left: 0;\n    }\n\n    .rbc-time-gutter,\n    .rbc-header-gutter,\n    .rbc-header,\n    .rbc-btn-group > button {\n        .flow-list-item-second-dark;\n        font-size: 11px;\n        word-break: inherit;\n    }\n\n    .rbc-time-gutter,\n    .rbc-header-gutter {\n        width: 12.5% !important;\n    }\n\n    .rbc-time-gutter {\n        white-space: normal;\n    }\n\n    .rbc-btn-group > button:focus {\n        outline: none;\n    }\n\n    .rbc-header.rbc-today {\n        .flow-list-item-second;\n        font-size: 11px;\n    }\n\n    .rbc-header {\n        padding: 3px;\n        white-space: inherit;\n    }\n\n    .rbc-day-slot .rbc-event {\n        border: none;\n        width: auto !important;\n    }\n\n    .rbc-event {\n        padding: 0;\n        background: transparent;\n        border-radius: 0px;\n        margin-right: -10px;\n\n        .rbc-addons-dnd-resizable {\n            height: 100%;\n        }\n\n        .rbc-event-label {\n            display: none;\n        }\n\n        .custom-event {\n            height: 100%;\n            display: flex;\n            flex-direction: row;\n\n            .event-placeholder {\n                width: 10px;\n                flex-shrink: 0;\n            }\n\n            .event-content {\n                word-break: break-word;\n\n                .custom-event-title {\n                    .flow-list-item-title;\n                    font-size: 12px;\n                    word-break: keep-all;\n                }\n\n                .custom-event-time {\n                    .flow-time;\n                    font-size: 11px;\n                }\n            }\n        }\n\n        .custom-event.non-editable {\n            cursor: not-allowed;\n        }\n    }\n\n    .profile-container {\n        margin: 20px 0 0;\n        display: flex;\n        flex-flow: row wrap;\n    }\n}\n\n.chat-session,\n.extension,\n.columns-1.onlyContent {\n    .custom-event-time,\n    .custom-event-title {\n        visibility: hidden;\n    }\n}\n","@import '~less-components/styles/flow-colors.less';\n\n//== Font faces to use\n\n/*\n//== Font classes to mixin\n@font-size-saturn:  14px;\n@font-size-neptune: 12px;\n@font-size-venus:   11px;\n@font-size-mars:    13px;\n@font-size-jackdaw: 11px;\n@font-size-magpie:  18px;\n@font-size-crow:    24px;\n@font-size-special: 16px;\n\n.flow-special-one {\n  font: @font-size-special 'Gotham Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-jupiter-one {\n  font: @font-size-jupiter 'Gotham Light';\n  color: @flow-app-dark-grey;\n}\n\n.flow-jupiter-invert {\n  font: @font-size-jupiter 'Gotham Light';\n  color: @flow-app-white;\n}\n\n.flow-saturn-one {\n  font: @font-size-saturn 'Gotham Book';\n  color: @flow-app-dark-grey;\n}\n\n.flow-saturn-two {\n  font: @font-size-saturn 'Gotham Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-saturn-three {\n  font: @font-size-saturn 'Gotham Book';\n  color: @flow-app-icon;\n}\n\n.flow-saturn-medium {\n  font: @font-size-saturn 'Gotham Medium';\n  color: @flow-app-dark-grey;\n}\n\n.flow-saturn-invert {\n  font: @font-size-saturn 'Gotham Book';\n  color: @flow-app-white;\n}\n\n.flow-saturn-light {\n  font: @font-size-saturn 'Gotham Light';\n  color: @flow-app-light-grey;\n}\n\n.flow-neptune-one {\n  font: @font-size-neptune 'Gotham Light'; // 0.875 = @font-size-neptune\n  color: @flow-app-light-grey;\n}\n\n.flow-neptune-two {\n    font: @font-size-neptune 'Gotham Book';\n    color: @flow-app-dark-grey;\n}\n\n.flow-neptune-three {\n  font: @font-size-neptune 'Gotham Book';\n  color: @flow-app-mid-grey;\n}\n\n.flow-neptune-bold {\n    font: @font-size-neptune 'Gotham Bold';\n    color: @flow-app-dark-grey;\n}\n\n.flow-neptune-medium {\n  font: @font-size-neptune 'Gotham Medium';\n  color: @flow-app-dark-grey;\n}\n\n.flow-neptune-medium-special {\n  font: @font-size-neptune 'Gotham Medium';\n  color: @flow-app-dark-grey;\n  letter-spacing: 1px;\n}\n\n.flow-neptune-invert {\n  font: @font-size-neptune 'Gotham Medium';\n  color: @flow-app-white;\n}\n\n.flow-venus-one {\n  font: @font-size-venus 'Gotham Book';\n  color: @flow-app-dark-grey;\n}\n\n.flow-venus-two {\n  font: @font-size-venus 'Gotham Book';\n  color: @flow-app-mid-grey;\n}\n\n.flow-venus-two-special {\n  font: @font-size-venus 'Gotham Light';\n  color: @flow-app-light-grey;\n  letter-spacing: 1px;\n}\n\n.flow-venus-three {\n  font: @font-size-venus 'Gotham Book';\n  color: @flow-app-light-grey;\n}\n\n// Only used for old video service remove when we the new video solution takes over.\n.flow-venus-special {\n  font: @font-size-venus 'Gotham Book';\n  color: @flow-app-red;\n}\n\n.flow-venus-invert {\n  font: @font-size-venus 'Gotham Book';\n  color: @flow-app-white;\n}\n\n.flow-venus-invert-60 {\n  font: @font-size-venus 'Gotham Book';\n  color: @flow-app-white;\n  opacity: 0.6;\n}\n\n.flow-mars-one {\n  font: @font-size-mars 'Gotham Book';\n  color: @flow-app-mid-grey;\n}\n\n.flow-mars-two {\n  font: @font-size-mars 'Gotham Book';\n  color: @flow-app-dark-grey;\n}\n\n.jackdaw {\n  font: @font-size-jackdaw 'Gotham Medium';\n  color: @flow-app-dark-grey;\n}\n\n.magpie {\n  font: @font-size-magpie 'Gotham Medium';\n  color: @flow-app-dark-grey;\n}\n\n.crow {\n  font: @font-size-crow 'Gotham Medium';\n  color: @flow-app-dark-grey;\n}\n*/\n\n//== Font classes to mixin\n@font-size-small: 12px;\n@font-size-medium: 12px;\n@font-size-large: 14px;\n@font-size-title-special: 16px;\n@font-size-midlarge: 18px;\n@font-size-xlarge: 24px;\n@font-size-special: 32px;\n\n.flow-title-special {\n  font: @font-size-title-special 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-special-font {\n  font: @font-size-special 'Roboto-Light';\n  color: @flow-app-mid-grey;\n}\n\n.flow-profile-bold {\n  font: @font-size-small 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-profile-regular {\n  font: @font-size-small 'Roboto-Regular';\n  color: @flow-app-dark-grey;\n}\n\n.flow-top-bar-title {\n  font: @font-size-large 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-list-item-title {\n  font: @font-size-large 'Roboto-Regular';\n  color: @flow-app-dark-grey;\n}\n\n.flow-list-item-title-alt {\n  font: @font-size-large 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-list-item-second {\n  font: @font-size-medium 'Roboto-Regular';\n  color: @flow-app-mid-grey;\n}\n\n.flow-list-item-second-dark {\n  font: @font-size-medium 'Roboto-Regular';\n  color: @flow-app-dark-grey;\n}\n\n.flow-list-item-second-alt {\n  font: @font-size-medium 'Roboto-Medium';\n  color: @flow-app-dark-icon;\n}\n\n.flow-list-item-third {\n  font: @font-size-small 'Roboto-Regular';\n  color: @flow-app-dark-icon;\n}\n\n.flow-list-item-third-alt {\n  font: @font-size-small 'Roboto-Bold';\n  color: @flow-app-dark-icon;\n}\n\n.flow-section-title {\n  font: @font-size-small 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-suggestion-item-title {\n  font: @font-size-medium 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-time {\n  font: @font-size-small 'Roboto-Regular';\n  color: @flow-app-mid-grey;\n}\n\n.flow-settings-item {\n  font: @font-size-large 'Roboto-Regular';\n  color: @flow-app-dark-grey;\n}\n\n.flow-settings-item-second {\n  font: @font-size-medium 'Roboto-Medium';\n  color: @flow-app-mid-grey;\n}\n\n.flow-settings-text {\n  font: @font-size-medium 'Roboto-Regular';\n  color: @flow-app-mid-grey;\n}\n\n.flow-settings-item-header {\n  font: @font-size-small 'Roboto-Regular';\n  color: @flow-app-mid-grey;\n}\n\n.flow-headline {\n  font: @font-size-xlarge 'Roboto-Bold';\n  color: @flow-app-dark-grey;\n}\n\n.flow-headline-two {\n  font: @font-size-large 'Roboto-Regular';\n  color: @flow-app-mid-grey;\n}\n\n.flow-headline-three {\n  font: @font-size-midlarge 'Roboto-Regular';\n  color: @flow-app-dark-grey;\n}\n\n.open-graph-title {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  text-overflow: ellipsis;\n  max-height: 34px;\n  overflow: hidden;\n  font: @font-size-large 'Roboto-Bold';\n  color: @flow-app-white;\n}\n\n.open-graph-description {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  text-overflow: ellipsis;\n  max-height: 32px;\n  overflow: hidden;\n  font: @font-size-medium 'Roboto-Regular';\n  color: @flow-app-ornament;\n}\n\n.open-graph-site-name {\n  font: 10px 'Roboto-Regular';\n  color: @flow-app-light-grey;\n}\n\n.callmodal-caller {\n  font: @font-size-large 'Roboto-Regular';\n  color: @flow-app-white;\n}\n\n.callmodal-info {\n  font: @font-size-medium 'Roboto-Regular';\n  color: @flow-app-light-grey;\n}\n\n.callmodal-state {\n  font: @font-size-medium 'Roboto-Bold';\n  color: @flow-app-white;\n}\n\n.flow-italic-one {\n  font: @font-size-medium 'Roboto-Regular';\n  color: @flow-app-light-grey;\n  font-style: italic;\n}\n\n.flow-italic-two {\n  font: @font-size-medium 'Roboto-Bold';\n  color: @flow-app-light-grey;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
